module.exports = __webpack_public_path__ + "static/media/mouth-sounds.cfd8c3c6.png";